import BikersHub from '../img/portImages//finalproject-c8f27.web.app_.png';
import Burger from '../img/portImages/burger-builder-c124e.web.app_.png';
import Clock from '../img/portImages/fahim-tonmoy.github.io_clock_.png';
import DoctorsPortal from '../img/portImages/doctorsportal-702b0.web.app_.png';
import Emajhon from '../img/portImages/youthful-engelbart-afe4f9.netlify.app_.png';
import Food from '../img/portImages/fahim-tonmoy.github.io_foodNetwork_.png';
import Football from '../img/portImages/fahim-tonmoy.github.io_responsive-football_.png';
import GitHub from '../img/portImages/fahim-tonmoy.github.io_githubFinder_.png';
import Honda from '../img/portImages/gifted-allen-5d5e36.netlify.app_.png';
import JSGames from '../img/portImages/fahim-tonmoy.github.io_Jsgame_.png';

const portfolios = [
    {
        id: 1,
        category: 'HTML & CSS',
        image: Food,
        link1: 'https://github.com/fahim-tonmoy/foodNetwork',
        link2: 'https://fahim-tonmoy.github.io/foodNetwork/',
        title: 'Responsive website template.',
        text: 'Created with only HTML and CSS.'
    },
    {
        id: 2,
        category: 'HTML & CSS',
        image: Honda,
        link1: 'https://github.com/fahim-tonmoy/honda-cbr',
        link2: 'https://gifted-allen-5d5e36.netlify.app/',
        title: 'Responsive website template.',
        text: 'Created with only HTML and CSS.'
    },
    {
        id: 3,
        category: 'ANIMATION',
        image: Football,
        link1: 'https://github.com/fahim-tonmoy/responsive-football',
        link2: 'https://fahim-tonmoy.github.io/responsive-football/',
        title: 'Animation Application',
        text: 'Responsive website template, with simple Animations'
    },
    {
        id: 4,
        category: 'JAVASCRIPT',
        image: Clock,
        link1: 'https://github.com/fahim-tonmoy/clock',
        link2: 'https://fahim-tonmoy.github.io/clock/',
        title: 'Clock',
        text: 'Simple Clock build with Vanilla JavaScript'
    },
    {
        id: 5,
        category: 'JAVASCRIPT',
        image: GitHub,
        link1: 'https://github.com/fahim-tonmoy/githubFinder',
        link2: 'https://fahim-tonmoy.github.io/githubFinder/',
        title: 'GitHub Finder',
        text: 'A gitHub finder build with Vanilla JavaScript'
    },
    {
        id: 6,
        category: 'JAVASCRIPT',
        image: JSGames,
        link1: 'https://github.com/fahim-tonmoy/Jsgame',
        link2: 'https://fahim-tonmoy.github.io/Jsgame/',
        title: 'Games',
        text: 'Simple Games build with Vanilla JavaScript'
    },
    {
        id: 7,
        category: 'REACT JS',
        image: Emajhon,
        link2: 'https://github.com/fahim-tonmoy/Ema-John-coder',
        link1: 'https://youthful-engelbart-afe4f9.netlify.app/',
        title: 'An Ecommerce With ReactJs',
        text: 'Created using different technologies such as React Bootstrap, Styled-Components and more...'
    },
    {
        id: 7,
        category: 'REACT JS',
        image: Burger,
        link2: 'https://github.com/fahim-tonmoy/BurgerBuilderClientSide',
        link1: 'https://burger-builder-c124e.web.app/',
        title: 'Burger Builder App',
        text: 'Created using different technologies such as React Bootstrap, Styled-Components and more...'
    },
    {
        id: 8,
        category: 'REACT JS',
        image: DoctorsPortal,
        link1: 'https://github.com/fahim-tonmoy/DoctorsPortalServerSide',
        link2: 'https://doctorsportal-702b0.web.app/',
        title: 'Doctors Portal',
        text: 'Created using different technologies such as Material UI, Styled-Components and more...'
    },
    {
        id: 9,
        category: 'REACT JS',
        image: BikersHub,
        link1: 'https://github.com/fahim-tonmoy/BikersHubClientSide',
        link2: 'https://finalproject-c8f27.web.app/',
        title: 'Bikers Hub',
        text: 'Created using different technologies such as React Bootstrap, Styled-Components and more...'
    }
]

export default portfolios;